 import React from "react";
//import Githubcalendar from "react-github-calendar";
import { ThemeContext } from "../../Context/theme";

// export const Github = () => {
//   const colourTheme = {
//     background: "transparent",
//     text: "#ffffff",
//     grade4: "#8400b8",
//     grade3: "#b22ff4",
//     grade2: "#b265f6",
//     grade1: "#c084f5",
//     grade0: "#ecd9fc",
//   };
//   const [{ themename }] = React.useContext(ThemeContext);

//   return (
//     <>
//       <div className={"section " + themename} data-aos="fade-right">
//         <h2 className="section__title different">
//           Days I <span className="different"> Code</span>
//         </h2>
//         <Githubcalendar
//           username="ruchipriya1009"
//           blockSize={15}
//           blockMargin={5}
//           theme={themename}
//           fontSize={16}
//         />
//       </div>
//     </>
//   );
// };





// import React from 'react'
 import "./github.css"

import GitHubCalendar from "react-github-calendar";

export const Github = () => {

    const selectLastHalfYear = (contributions) => {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();
        const shownMonths = 5;

        return contributions.filter((day) => {
            const date = new Date(day.date);
            const monthOfDay = date.getMonth();

            return (
                date.getFullYear() === currentYear ||
                monthOfDay > currentMonth - shownMonths ||
                monthOfDay <= currentMonth
            );
        });
    };



    return (
        <section id='github'>
            <h2 className="git">GitHub</h2>
            <div className='container container_github'>
                <div className='calendar'>
                    <GitHubCalendar  className="react-activity-calendar"
                        username="ruchipriya1009"
                        transformData={selectLastHalfYear}
                        // year={new Date().getFullYear()}
                        color="4f4c4c"
                        width="100vw"
                    />
                </div>
                
                <div className='contribution' >
                    {/* <img id="github-streak-stats" src="https://streak-stats.demolab.com/?user=ruchipriya1009&theme=gruvbox&border_radius=15&date_format=M%20j%5B%2C%20Y%5D&color=4db5ff" alt="contribution" /> */}
                    <img id="github-streak-stats" src="https://github-readme-streak-stats.herokuapp.com/?user=ruchipriya1009" alt="streak"></img>
                </div>
                <div className="lang">
                <div className='language'>
                    <img id="github-top-langs" src="https://github-readme-stats.vercel.app/api/top-langs/?username=ruchipriya1009" alt="language" />
                </div>
                </div>
                <div className='stats'>
                    <img id="github-stats-card"  src="https://github-readme-stats.vercel.app/api?username=ruchipriya1009" alt="stats" />
                </div>
                
            </div>




        </section>

    )
}

//export default Github